// Format a decimal quantity as a clean fraction string
// Examples: 0.25 → "1/4", 1.5 → "1 1/2", 0.33 → "1/3", 3 → "3"
const FRACTION_MAP = [
  [1/8, '1/8'], [1/6, '1/6'], [1/4, '1/4'], [1/3, '1/3'],
  [3/8, '3/8'], [1/2, '1/2'], [5/8, '5/8'], [2/3, '2/3'],
  [3/4, '3/4'], [5/6, '5/6'], [7/8, '7/8'],
];

export function toFraction(value) {
  if (!value || value <= 0) return '0';
  const whole = Math.floor(value);
  const remainder = value - whole;
  if (remainder < 0.01) return `${whole}`;
  const match = FRACTION_MAP.find(([dec]) => Math.abs(remainder - dec) < 0.03);
  if (match) {
    return whole > 0 ? `${whole} ${match[1]}` : match[1];
  }
  return `${Math.round(value * 100) / 100}`;
}
